import { useTranslation } from 'react-i18next';
import { Box, styled, useTheme } from '@mui/material';

import { EmbedTranscriptComponent } from './types';

export const EmbedStep = ({
  transcriptComponent,
}: {
  transcriptComponent: EmbedTranscriptComponent;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const theme = useTheme();

  return (
    <Container>
      <Box
        sx={{
          aspectRatio: '16 / 9',
        }}
      >
        <Box
          allowFullScreen
          component='iframe'
          name={t('embedStep.title')}
          referrerPolicy='strict-origin-when-cross-origin'
          src={transcriptComponent.embed_url}
          sx={{
            border: `1px solid ${theme.palette.colors.slate[200]}`,
            borderRadius: '8px',
            height: '100%',
            width: '100%',
          }}
          title={t('embedStep.title')}
        />
      </Box>
    </Container>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- TODO: fix later
export const Container = styled('div')`
  background-color: transparent;
  margin-left: 4px;
`;
